export default class Lazy {
  constructor() {
    this.imgsSelector = '[data-src]';
  }
  
  init() {
    const imgs = $(this.imgsSelector);

    imgs.each((i, e) => {
      const element = $(e);

      const src = element.data('src');

      if (element.data('src-background') === true) {
        element.css('background-image', `url(${src})`);
      } else {
        element.attr('src', src);
      }
    });
  }
}
